<template>
    <v-container class="container h-100 align-content-center">
        <v-row justify="center" class="mb-4">
            <v-col cols="12" class="text-center">
                <v-card elevation="0" color="transparent">
                    <v-card-title class="headline font-weight-bold text-blue-onfly w-100">
                        <div class="mx-auto">
                            <span>Bem-vindo(a) à Onfly!</span>
                        </div>
                    </v-card-title>
                    <v-card-text class="subtitle-1 text-secondary">
                        Estamos animados para começar uma jornada de sucesso com você!
                        <br />
                        Complete o pré-cadastro abaixo para darmos o primeiro passo.
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <pre-registration />
    </v-container>
</template>

<script>
import PreRegistration from "../../components/Hotel/HotelForm/PreRegistration.vue";

export default {
    name: "OwnerCreationPreRegistration",
    components: {
        PreRegistration
    }
}
</script>

<style scoped>

.text-blue-onfly {
    color: #1976D2;
}

.text-secondary {
    color: rgba(84, 102, 122, 0.7) !important;
    font-weight: 500 !important;
}

.container {
    width: 80%;
}

@media (max-width: 6768px) {
    .container {
        width: 90%;
    }
}

</style>
